// These schemas should match their corresponding DB model in @performyard/models
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AutoflowTaskConsole () {
        return AutoflowTaskConsole;
    },
    get AutoflowTaskConsoleBase () {
        return AutoflowTaskConsoleBase;
    },
    get AutoflowTaskConsoleLog () {
        return AutoflowTaskConsoleLog;
    },
    get AutoflowTaskConsoleLogResponse () {
        return AutoflowTaskConsoleLogResponse;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _taskbase = require("./task-base");
const AutoflowTaskConsoleBase = _taskbase.AutoflowTaskBase.extend({
    taskType: _zod.z.literal("console:")
});
const AutoflowTaskConsoleLog = AutoflowTaskConsoleBase.extend({
    taskType: _zod.z.literal("console:log"),
    inputs: _zod.z.record(_zod.z.string(), _zod.z.record(_zod.z.string(), _utilsisomorphic.transformObjectId.array().or(_zod.z.null()))).optional(),
    config: _zod.z.object({
        template: _zod.z.string(),
        header: _zod.z.string().optional(),
        footer: _zod.z.string().optional(),
        params: _zod.z.record(_zod.z.string(), _zod.z.string()).optional()
    })
});
const AutoflowTaskConsoleLogResponse = _taskbase.AutoflowTaskBaseResponse.merge(AutoflowTaskConsoleLog);
const AutoflowTaskConsole = _zod.z.discriminatedUnion("taskType", [
    AutoflowTaskConsoleBase,
    AutoflowTaskConsoleLog
]);
